// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-2WfFdAap clearfix","list":"list-140Ugv5S"};